import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import InformationCircleIcon from 'material-ui-apollo-icons/InformationCircle';
import React from 'react';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
  popper: {
    width: '15%',
  },
  infoLabelIcon: {
    height: '18px',
    width: '18px',
    pointerEvents: 'auto',
  },
};

export const InfoLabel = ({ label, tooltip, iconClassName, classes }) => (
  <Grid container spacing={8} alignItems="center">
    <Grid item>{label}</Grid>
    <Grid item className={iconClassName}>
      <Tooltip title={tooltip} PopperProps={{ className: classes.popper }}>
        <InformationCircleIcon className={classes.infoLabelIcon} />
      </Tooltip>
    </Grid>
  </Grid>
);

InfoLabel.displayName = 'InfoLabel';

export default withStyles(styles, { name: 'InfoLabel' })(InfoLabel);



// WEBPACK FOOTER //
// ./src/Shared/Forms/InfoLabel.js